export const extractMenuItems = (menu) =>
  menu.attributes.items.map(({ label, uri }) => ({
    href: uri,
    children: label,
  }))
